<div class="py-3">
    <div class="reset-container resetpass-wrap">
       <div class="reset-inner" *ngIf="!iFrameInit">
        <div><span class="patient-sign" (click)="redirectCheck()">Patient eSignature Authorization Form</span></div>
        <div>
            <div class="patSignHead"><span class="patSign">Welcome to the Patient eSignature Authorization form page for ViiVConnect.</span></div>
            <br>
            <div><span class="patSign">If a ViiVConnect Patient Enrollment Form has been completed and submitted to ViiVConnect (by fax, mail, or phone), but you were unable to sign it, you may use the abbreviated form below to provide your signature electronically, so that we can process the Patient Enrollment Form that you or your healthcare provider previously submitted.</span></div>
        </div>
        <form #patientEsignatureForm="ngForm" (ngSubmit)="onSubmitEsignForm(patientEsignatureForm)">
                  <div class="col-md-12 form-container">
                    <div class="flex-column form-layout">

                          <!-- Patient First Name  -->
                          <div class="pt-2 form-group  input-align">
                            <label class=" label form-label-val"> Patient First Name  <span class="astrick">*</span> </label>

                            <input type="text" class="input-padding form-control text-box text" 
                            name="patientFirstName" id="patientFirstName" ngModel #patientFirstName="ngModel" placeholder="Enter Patient First Name" (change)="eSignatureFormValues(patientEsignatureForm)"
                            required />      
                              
                          </div>                 
                
                          

                          <!-- Enter Patient Last Name -->
                          <div class="pt-2 tm-1 form-group input-align">
                            <label class=" label form-label-val"> Patient Last Name <span class="astrick">*</span> </label>
                          
                              <input type="text" class=" input-padding  form-control text-box text" id="patientLastName"
                                name="patientLastName" ngModel  #patientLastName="ngModel" placeholder="Enter Patient Last Name" (keyup)="eSignatureFormValues(patientEsignatureForm)"
                                required />
                                
          
                          </div>

                          <!--  Date of Birth -->
                          <div class="pt-2 tm-1 form-group input-align">
                            <label class=" label form-label-val"> Date of Birth <span class="astrick">*</span> </label>
                                 <div class="text-box dob-container">
                                    <input class="form-control text-box text date-container" [minDate]="{year: 1900, month: 1, day: 1}"
                                      [maxDate]="this.todaysDate" placeholder="mm/dd/yyyy" (blur)="eSignatureFormValues(patientEsignatureForm)" 
                                      name="patientDOB" id="patientDOB" [(ngModel)]="patientDOB" ngbDatepicker #dob="ngbDatepicker"
                                      placement="end-top" required (click)="dob.toggle()" />
                                    <img *ngIf="!existingpatientbutton" src="../../../../assets/images/date-picker-icon.png"
                                      (click)="dob.toggle()" class="dob-calander-icon" />                                      
                                  </div>   
                          </div>
                          <!-- Zip Code -->
                          <div class="pt-2 tm-1 form-group input-align">
                            <label class=" label form-label-val"> Zip Code <span class="astrick">*</span> </label>
                          
                              <input type="text" class=" input-padding form-control text-box text" id="zipCode" name="zipCode" ngModel
                                #zipCode="ngModel" placeholder="Enter Zip Code" (blur)="eSignatureFormValues(patientEsignatureForm)" maxlength="5"
                                minlength="5" autocomplete="off" appNumberonly required />
                              
                            
                          </div>
                          <!-- Email -->

                          <div class="pt-2 form-group input-align">
                            <label class=" label form-label-val"> Email <span class="astrick">*</span> </label>
                              <input type="email" 
                              class="input-padding  form-control text-box text"   
                              ngModel
                              #PatientEmail="ngModel" 
                              [(ngModel)]="patientEmail"  
                              name="patientEmail"
                              id="patientEmail"
                              placeholder="Enter Email"
                              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$"
                              (change)="eSignatureFormValues(patientEsignatureForm)" required />
                          </div>

                          <!-- Signed By -->
                              <div class="pt-2 form-group input-align">
                                <label class=" label form-label-val"> Signed By <span class="astrick">*</span> 
                                </label>
                                <ng-select class="form-control text-box text custom-dropdown input-padding "
                                  id="EconsentSignedBy" [clearable]="false" name="EconsentSignedBy" [(ngModel)]="EconsentSignedBy"
                                  (change)="eSignatureFormValues(patientEsignatureForm)" required> 
                                  <ng-option selected disabled value="" >Select Signed by</ng-option>
                                  <ng-option selected value="Patient">Patient</ng-option>
                                  <ng-option value="Caregiver">Caregiver</ng-option>
                                </ng-select>
                              </div>
                          <!-- Caregiver first Name  -->
                          <div class="pt-2 form-group input-align"  *ngIf="showCaregiverOptions">
                            <label class=" label form-label-val"> Caregiver First Name <span class="astrick">*</span> </label>
                         
                              <input type="text" class="input-padding form-control text-box text" name="caregiverFirstName"
                                id="caregiverFirstName" [(ngModel)]="caregiverFirstName" #CaregiverName="ngModel" placeholder="Enter Caregiver's First Name"
                                (change)="eSignatureFormValues(patientEsignatureForm)" required />
                              
                          </div>

                          <!-- Caregiver last Name  -->
                          <div class="pt-2 form-group input-align" *ngIf="showCaregiverOptions">
                            <label class=" label form-label-val"> Caregiver Last Name <span class="astrick">*</span> </label>
                              <input type="text" class="input-padding form-control text-box text" name="caregiverLastName" id="caregiverLastName"
                                [(ngModel)]="caregiverLastName" #CaregiverName="ngModel" placeholder="Enter Caregiver's Last Name"
                                (change)="eSignatureFormValues(patientEsignatureForm)" required />
                              
                          </div>

                          <!-- Relation to patient -->

                          <div class="pt-2 form-group  input-align" *ngIf="showCaregiverOptions">
                            <label class=" label form-label-val">Relation to Patient<span class="astrick">*</span>
                            </label>
                            <ng-select class="form-control text-box text custom-dropdown input-padding " id="relationToPatient" [clearable]="false"
                              name="relationToPatient" [(ngModel)]="relationToPatient" required>
                              <ng-option value="" selected disabled>
                                Select relationship to patient
                              </ng-option>
                              <ng-option selected value="UNKNOWN">Unknown</ng-option>
                              <ng-option value="Spouse">Spouse</ng-option>
                              <ng-option value="Father">Father</ng-option>
                              <ng-option value="Mother">Mother</ng-option>
                              <ng-option value="Dependent">Dependent</ng-option>
                            </ng-select>
                          </div>
                    </div>
                  </div>

        <div class="bottom-text-container">
            <div><span class="pat-esign-title">Need Help?</span></div>
            <div class="pt-1">
                <div><span class="pat-esign-text">Dedicated Access Coordinators can explain the features and benefits of ViiV Connect. Learn more about programs for eligible patients who are insured, underinsured, and uninsured.</span></div>
                <div style="padding-top:15px;"><span class="pat-esign-text">Talk one-on-one live with a dedicated Access Coordinator. 1-844-588-3288 (toll free) Monday – Friday, 8AM – 11PM (ET) Multilingual options available.</span></div>
            </div>
        </div>
        
        <div class="btn-container">
          <!-- {{zipCode1}}
          {{patientLastName1}}
          {{patientFirstName1}} -->
            <button [disabled]="!patientEsignatureForm.valid" class="btn btn-style review-btn mb-3 confirm button" type="submit" >
                Review & Sign Electronically
            </button>
        </div>
      </form>
       
        <div style="padding-top:10px;" class="par-esign-btm-txt">This site is intended for US residents 18 years of age or older. </div>
    </div>
    <div *ngIf="iFrameInit && showIframe" class="ds-content-inner-patientref">
      <iframe [src]="docuSignUrl | safe:'resourceUrl'" style="height: 600px; width: 100%;" id="iframe_id"></iframe>
         <!-- <iframe src="http://localhost:4200/#/redirect-patient-esignature-authorization?event=signing_complete"
         style="height: 600px; width: 100%;" id="iframe_id"></iframe> -->
    </div>
  </div>
  